import { AppointmentID } from "./Appointment";
import { ChecklistID } from "./Checklist";
import { UserID } from "./User";

export type PausedCarCheckID = number;

export interface PausedCarCheck {
  created_on: string;
  updated_on: string;
  id: PausedCarCheckID; // Claire paused check ID
  appointment_id: AppointmentID; // Claire appointment ID
  checklist_id: ChecklistID; // Claire checklist ID
  user_id: UserID; // ID of the user who paused the check
  url: string; // URL of the serialized java check
}
